
import { supabase } from '@/integrations/supabase/client';
import { User } from '../types';
import { fetchUserProfile } from '../utils';
import { handleAuthError } from '../utils/errors';

export async function getCurrentSession() {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    
    if (error) throw error;
    
    return session;
  } catch (error) {
    return handleAuthError(error);
  }
}

export async function getUserFromSession(session: any): Promise<User | null> {
  if (!session) return null;
  
  try {
    return await fetchUserProfile(session.user);
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return null;
  }
}
